import { TSwap } from "@/types";
import styles from "./index.module.scss";
import { RemoveSvg, PlusSvg, SwapArrowdSvg } from "@/assets/icons";
import { MouseEventHandler } from "react";
import { useCommonStore } from "@/stores";
import { Tooltip } from "@/components";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import clsx from "clsx";

type SwapProps = {
  disabled?: boolean;
  onRemoveTarget: () => void;
  onChooseTarget: () => void;
} & TSwap;

const Swap = (props: SwapProps) => {
  const { source, target, loading, disabled, onRemoveTarget, onChooseTarget } =
    props;

  const { t } = useTranslation();

  const generating = useCommonStore((state) => state.generating);
  const isLimitFace = useCommonStore((state) => state.getters.isLimitFace);

  const onClickClose: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onRemoveTarget();
  };

  const handleClickUpload = () => {
    if (isLimitFace) {
      toast(t("face_limit_tip"));
      return;
    }

    onChooseTarget();
  };

  return (
    <div className={styles["root"]}>
      <img
        className={styles["source_head"]}
        src={source.resource.url || source.resource.blobUrl}
        alt=""
      />
      <div className={styles["arrow"]}>
        <SwapArrowdSvg></SwapArrowdSvg>
      </div>

      <div
        className={clsx(
          styles["target_wrap"],
          loading && styles["target_wrap_loading"]
        )}
      >
        {target ? (
          <button
            className={styles["target_head_wrap"]}
            disabled={generating}
            onClick={onChooseTarget}
          >
            <img
              className={styles["target_head"]}
              src={target.resource.url || target.resource.blobUrl}
              alt=""
            />

            {!loading && (
              <button
                className={styles["close_button"]}
                disabled={generating}
                onClick={onClickClose}
              >
                <RemoveSvg></RemoveSvg>

                {/* {!generating && (
                  <Tooltip content={t("remove_tip")} placement="top"></Tooltip>
                )} */}
              </button>
            )}
          </button>
        ) : (
          <button
            className={clsx(styles["target_upload_button"],loading && styles["target_upload_button_loading"])}
            disabled={generating}
            onClick={handleClickUpload}
          >
            <PlusSvg></PlusSvg>
          </button>
        )}
        {loading && (
          <div
            className={clsx(styles["loading_wrap"], "skeleton_loading")}
          ></div>
        )}
      </div>
    </div>
  );
};

export default Swap;
